export enum EMPTY_STATE_TYPE {
    EMPTY_COLLECTION,
    EMPTY_DASHBOARD,
    EMPTY_SEARCH,
    ERROR,
    NOT_CONFIGURED,
}

export enum EMPTY_STATE_STATUS {
    OK,
    EMPTY,
    NOT_CONFIGURED,
}
